module.exports = __webpack_public_path__ + "static/media/valor1_1_2.711ca74f.png";